<div class="help-panel-backdrop" [class.open]="isOpen" (click)="close()"></div>

<div class="help-panel" [class.open]="isOpen" role="dialog" aria-label="User Guide panel">
  <div class="help-panel__header">
    <span class="help-panel__title">
      <mat-icon class="material-symbols-outlined">help</mat-icon>
      User Guide
    </span>
    <div class="help-panel__actions">
      <button class="help-panel__open-btn" (click)="openFullGuide()" matTooltip="Open full guide in new tab" matTooltipPosition="below">
        <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
        <span>Open full guide</span>
      </button>
      <button class="help-panel__close-btn" (click)="close()" aria-label="Close user guide panel">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="help-panel__body">
    <iframe
      *ngIf="isOpen"
      [src]="panelUrl"
      class="help-panel__iframe"
      title="User Guide"
      frameborder="0"
    ></iframe>
  </div>
</div>
